import { DetalleParametrosRegimenProyeccionHE } from "components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras";
import React, { Dispatch, SetStateAction, useState } from "react";


type ContextoParametrosHorasExtras = {
    consultandoParametrosAnio: boolean,
    setconsultandoParametrosAnio: Dispatch<SetStateAction<boolean>>,
    guardandoParametro:boolean,
    setguardandoParametro:Dispatch<SetStateAction<boolean>>,
    anioParametrosSeleccionado:number|null,
    setanioParametrosSeleccionado:  Dispatch<SetStateAction<number | null>>,

    creandoParametros:boolean,
    setcreandoParametros: Dispatch<SetStateAction<boolean>>,
    parametrosHorasRegimen:DetalleParametrosRegimenProyeccionHE[]|null,
    setparametrosHorasRegimen:Dispatch<SetStateAction<DetalleParametrosRegimenProyeccionHE[]|null>>,
    recargarGruposActivos:boolean,
    setrecargarGruposActivos: Dispatch<SetStateAction<boolean>>,
    
    recargarInformacionGeneralGrupos:boolean,
    setrecargarInformacionGeneralGrupos: Dispatch<SetStateAction<boolean>>,

}



const ParametrosHorasExtrasContext = React.createContext<ContextoParametrosHorasExtras | undefined>(undefined);


export function useParametrosHorasExtrasContext() {
    const contexto = React.useContext(ParametrosHorasExtrasContext);
    if (!contexto) {
        throw new Error('Para usar el hook asegurese de ser hijo del Proveedor ParametrosHorasExtrasContextProvider');
    }
    return contexto;
}

const ParametrosHorasExtrasContextProvider:React.FC = ({children}) => {
    const [consultandoParametrosAnio, setconsultandoParametrosAnio] = useState<boolean>(false);
    const [guardandoParametro, setguardandoParametro] = useState<boolean>(false);
    const [creandoParametros, setcreandoParametros] = useState<boolean>(false);

    const [anioParametrosSeleccionado, setanioParametrosSeleccionado] = useState<number|null>(null);
    const [parametrosHorasRegimen, setparametrosHorasRegimen] = useState<DetalleParametrosRegimenProyeccionHE[]|null>(null);

    const [recargarGruposActivos, setrecargarGruposActivos] = useState<boolean>(false);
    const [recargarInformacionGeneralGrupos, setrecargarInformacionGeneralGrupos] = useState<boolean>(false);



    const value:ContextoParametrosHorasExtras = {
        consultandoParametrosAnio,
        setconsultandoParametrosAnio,
        guardandoParametro,
        setguardandoParametro,
        anioParametrosSeleccionado,
        setanioParametrosSeleccionado,
        creandoParametros,
        setcreandoParametros,
        parametrosHorasRegimen,
        setparametrosHorasRegimen,
        recargarGruposActivos,
        setrecargarGruposActivos,
        recargarInformacionGeneralGrupos,
        setrecargarInformacionGeneralGrupos

    }
  
    return (
  
        <ParametrosHorasExtrasContext.Provider value={value}>
            {children}
        </ParametrosHorasExtrasContext.Provider>
    
    )
  }
  
  export default ParametrosHorasExtrasContextProvider;
  